/*--------------------------------------
	불러톡 — 이미지 미디어 (ChatPhoto)

	이미지 업로드 시작 + 업로드 완료 후 전송 + 이미지 새창보기 + 드롭 파일 처리.
	상태는 메인 Chat(this.chat)이 보유하며, 전송은 chat.ajax / chat 에 위임.
--------------------------------------*/
import Util from '../../Common/Util';
export default class ChatPhoto {
	/**
	 * @param chat 메인 Chat 인스턴스(상태 공유)
	 */
	constructor(chat){
		this.chat = chat;
		this.stickerGiven = {};   // 회원번호 → 스티커 포인트 이미 받음(true). 사진을 열 때마다 묻지 않도록 캐시
	}

	/**
	 * 카메라/갤러리 업로드 시작 (완료는 EventBus 'upload:image' → onFileUploaded).
	 * @param uptype 'camera' | 'gallery'
	 */
	startImageUpload(uptype){
		$j.F.Upload.addPhotoHere({ tag:'talk', context:'chatUpload', max_sheet:5, from: (uptype === 'camera') ? 'C' : 'G' });
		$('#chatAttachMenu').removeClass('is-open'); // 선택 메뉴 닫기
	}

	/**
	 * 업로드 완료 → 각 파일을 메세지로 전송.
	 * @param file 업로드 결과(단건 또는 배열)
	 */
	onFileUploaded(file){
		const chat = this.chat;
		const files = Array.isArray(file) ? file : [file];
		$.each(files, function(i, row){ chat.ajax.sendMessageToGo(row.id); });
	}

	/**
	 * 이미지 새창(줌) 보기.
	 *
	 * 관리자 상담창(/adm/chat)에서는 [스티커인증샷] 버튼이 함께 뜬다 — 회원이 장비에 붙인
	 * 스티커 사진을 톡으로 보내오면 CS 가 그 자리에서 500P 를 준다. 회원 앱에는 버튼이 없다.
	 * 각 사진에 보낸이(mbNo)를 실어두므로 갤러리를 넘겨도 지금 보는 사진의 주인에게 지급된다.
	 *
	 * 이미 받은 회원이면 버튼을 아예 그리지 않는다 — 눌러도 서버가 되돌리는 헛클릭이다.
	 * 판정은 **연 사진의 보낸이 기준**이라, 갤러리를 다른 사람 사진으로 넘긴 채 누르면
	 * 버튼이 남아 있을 수 있다. 그건 서버(givePoint)가 사유와 함께 막는다.
	 *
	 * @param tar 클릭된 이미지 엘리먼트
	 */
	showImage(tar){
		const items = [];
		let idx = 0;
		const fileId = $(tar).attr('id').replace('chatImage_', '');
		$('img[id^="chatImage_"]').each(function(i){
			const id = $(this).attr('id').replace('chatImage_', '');
			const src = Util.toOriginalUrl($(this).attr('src'));
			const $row = $(this).closest('.chat-row');
			items.push({
				url:  src,
				mbNo: parseInt($row.attr('data-mbno')) || 0,
				mgr:  $row.attr('data-mgr') == '1',      // 상담원이 보낸 사진 — 지급 대상이 아니다
			});
			if( id == fileId ) idx = i;
		});
		if( !items.length ) return;

		const open = (actions) => $j.Ui.ZoomPhoto.open(null, { items, index: idx, downloadable: true, actions });

		if( !this.chat.isAdminPage ){ open([]); return; }   // 회원 화면 — 버튼 없음

		this.checkStickerGiven(items[idx], (canGive) => {
			open(canGive
				? [{ label: '스티커인증샷 500P 지급', onClick: (item) => this.giveStickerPoint(item.mbNo, item.mgr) }]
				: []);
		});
	}

	/**
	 * 이 사진에 스티커 지급 버튼을 붙일 수 있는지 (관리자 전용).
	 * 상담원 사진·보낸이 불명이면 묻지도 않는다. 회원번호별 결과는 캐시해 재조회하지 않는다.
	 * 조회가 실패하면 버튼을 그린다 — 중복은 어차피 서버가 막으므로, 못 눌러 놓치는 쪽이 나쁘다.
	 *
	 * @param item 지금 여는 사진 { mbNo, mgr }
	 * @param cb   (canGive:boolean) => void
	 */
	checkStickerGiven(item, cb){
		const mbNo = item && item.mbNo;
		if( !item || item.mgr || !(mbNo > 0) ){ cb(false); return; }
		if( this.stickerGiven[mbNo] !== undefined ){ cb(!this.stickerGiven[mbNo]); return; }

		$.getJSON(`/adm/ajax/member/${mbNo}/point/given`)
			.done((d) => {
				this.stickerGiven[mbNo] = !!(d && d.sticker);
				cb(!this.stickerGiven[mbNo]);
			})
			.fail(() => cb(true));
	}

	/**
	 * 스티커인증샷 포인트 지급 (관리자 전용).
	 * 기사관리의 [스티커 인증샷 500점 지급] 과 **같은 엔드포인트**다 — 중복지급 차단·상담이력
	 * 기록이 서버(MemberController@givePoint) 한 곳에 있어야 톡에서 줬는지 기사관리에서 줬는지
	 * 따질 필요가 없다. 회원당 1회로 막히는 것도 서버가 판단한다.
	 *
	 * @param mbNo  사진을 보낸 회원번호
	 * @param isMgr 상담원이 보낸 사진인지 (그렇다면 지급 대상이 아니다)
	 */
	giveStickerPoint(mbNo, isMgr){
		// 알림은 화면 관례를 따른다 — 상담원 화면(/adm·/ma)엔 $j.F.Admin.Util.tsalert, 회원 화면엔 Toast
		const notify = (kind, msg) => {
			if( this.chat.isAdminPage ) $j.F.Admin.Util.tsalert(kind, msg);
			else $j.Ui.Toast.show(kind, msg);
		};

		if( isMgr ){
			notify('warning', '상담원이 보낸 사진입니다. 회원이 보낸 인증샷에서 지급해 주세요.');
			return;
		}
		if( !(mbNo > 0) ){
			notify('warning', '보낸사람을 확인할 수 없습니다.');
			return;
		}
		Util.swalert(['스티커 인증샷 500P 를 지급할까요?', 'question'], () => {
			$.post(`/adm/ajax/member/${mbNo}/point`, { togoPoint: 500, typenum: 15, chmemno: 0 }, (d) => {
				// 중복지급·이미 지급됨은 서버가 사유를 돌려준다 (회원당 1회)
				if( !d || d.result === false ){
					// 막힌 사유는 여러가지(이미지급·설정값오류)라 캐시를 단정하지 않고 비운다.
					// 다음에 사진을 열 때 서버에 다시 묻는다.
					delete this.stickerGiven[mbNo];
					notify('warning', (d && d.message) || '지급하지 못했습니다.');
					return;
				}
				this.stickerGiven[mbNo] = true;
				$j.Ui.ZoomPhoto.hideActions();   // 방금 준 사람 — 열려있는 뷰어에서도 버튼을 걷는다
				notify('success', '스티커인증샷 500P 지급 완료');
			}, 'json');
		}, ['지급', '취소']);
	}

	/**
	 * 드롭/선택 파일을 폼에 담아 업로드(소켓 접속자 확인 후 전송).
	 * @param files FileList
	 */
	readFiles(files){
		const chat = this.chat;
		const formData = new FormData();
		formData.append('room_num', chat.roomno);
		$.each(files, function(i, f){ formData.append('file[]', f); });
		chat.socket.sendFileToDb(formData);
	}
}